import { STORY_BASE_PATH, STORY_NAVIGATION_EVENT } from './config';

export { STORY_NAVIGATION_EVENT } from './config';

export type ThreeSecStoryRoute =
  | { kind: 'landing' }
  | { kind: 'record'; templateId: string };

const STORY_RECORD_PREFIX = `${STORY_BASE_PATH}/record/`;

const normalizeStoryPath = (pathname: string): string => {
  if (pathname.length > STORY_BASE_PATH.length && pathname.endsWith('/')) {
    return pathname.slice(0, -1);
  }

  return pathname;
};

export const isThreeSecStoryPath = (pathname: string): boolean => {
  const normalized = normalizeStoryPath(pathname);
  return normalized === STORY_BASE_PATH || normalized.startsWith(STORY_RECORD_PREFIX);
};

export const getThreeSecStoryRoute = (pathname: string): ThreeSecStoryRoute | null => {
  const normalized = normalizeStoryPath(pathname);

  if (normalized === STORY_BASE_PATH) {
    return { kind: 'landing' };
  }

  if (!normalized.startsWith(STORY_RECORD_PREFIX)) {
    return null;
  }

  const templateId = decodeURIComponent(normalized.slice(STORY_RECORD_PREFIX.length)).trim();
  if (!templateId || templateId.includes('/')) {
    return null;
  }

  return { kind: 'record', templateId };
};

export const navigateToStoryPath = (pathname: string, replace = false) => {
  const nextPath = normalizeStoryPath(pathname);
  if (replace) {
    window.history.replaceState(null, '', nextPath);
  } else {
    window.history.pushState(null, '', nextPath);
  }
  window.dispatchEvent(new Event(STORY_NAVIGATION_EVENT));
};
